<div class="py-4 container-fluid compensation-rates-page">
  <h4 class="compensation-rates-title">การตั้งค่า - อัตราเบิกจ่าย</h4>

  <section class="compensation-rates-card" aria-labelledby="regular-maximum-heading">
    <div class="compensation-rates-card-body" [formGroup]="form">
      <div class="compensation-rates-card-heading-row">
        <div>
          <h5 id="regular-maximum-heading">อัตราเบิกจ่ายของหลักสูตรภาคปกติ</h5>
          <p>กำหนดอัตราเบิกจ่ายค่าสอนเกินภาระงานของหลักสูตรภาคปกติของแต่ละภาคการศึกษา ซึ่งใช้ร่วมกันทั้งคณะ</p>
        </div>
        @if (setting()?.source === 'default') {
          <span class="compensation-rates-source-badge">ค่าเริ่มต้นของระบบ</span>
        } @else if (setting() !== null) {
          <span class="compensation-rates-source-badge configured">ตั้งค่าสำหรับเทอมนี้แล้ว</span>
        }
      </div>
  @if (settingLocked) {
        <div class="compensation-rates-notice" role="status">
          {{ settingLockedMessage }}
        </div>
      }
      <div class="compensation-rates-form-row">
        <app-select
          label="ปีการศึกษา"
          formControlName="academicYear"
          [options]="academicYearOptions"
          [searchable]="false"
          [clearable]="false"
          inputClass="ng-select-size-md"
          classes="mb-0">
        </app-select>
        <app-select
          label="เทอมการศึกษา"
          formControlName="academicTerm"
          [options]="academicTermNameOptions"
          [searchable]="false"
          [clearable]="false"
          inputClass="ng-select-size-md"
          classes="mb-0">
        </app-select>
        <app-input
          label="อัตราเบิกจ่าย"
          formControlName="regularMaxAmount"
          [isCurrency]="true"
          inputClass="app-input-size-md"
          classes="mb-0"
          [required]="true"
          [error]="form.controls.regularMaxAmount.touched ? form.controls.regularMaxAmount.errors : null">
        </app-input>
      </div>

      @if (loading()) {
        <div class="compensation-rates-notice" role="status">กำลังโหลดข้อมูล...</div>
      }
      @if (loadError()) {
        <div class="compensation-rates-notice danger" role="alert">{{ loadError() }}</div>
      }
    

      <div class="compensation-rates-footer">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="loading() || saving() || recalculationActive || settingLocked || form.invalid"
          (click)="openSaveConfirm()">
          {{ recalculationActive ? 'กำลังคำนวณ...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </section>
</div>

<app-confirm-dialog
  #saveConfirmDialog
  modalId="compensationRateSaveConfirm"
  icon="warning"
  title="ยืนยันการเปลี่ยนวงเงิน"
  message="ต้องการบันทึกวงเงินใหม่หรือไม่? ระบบจะคำนวณข้อมูลของเทอมนี้ใหม่ และอาจดึงใบส่งเบิกที่ยังดำเนินการอยู่กลับไปรับรองอีกครั้ง"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="saving()"
  (confirmed)="save()">
</app-confirm-dialog>

<app-confirm-dialog
  #saveSuccessDialog
  modalId="compensationRateSaveSuccess"
  icon="success"
  title="บันทึกวงเงินสำเร็จ"
  message="บันทึกวงเงินแล้ว ระบบกำลังคำนวณข้อมูลของเทอมนี้ใหม่"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="saveSuccessDialog.close()">
</app-confirm-dialog>
